<template>
  <v-layout column class="pagemargin page">
    <!--Charts -->
    <v-layout row wrap>
      <v-flex md12>
        <v-toolbar color="secondary">
          <v-toolbar-title class="font-weight-thin white--text">
            Print Report for
            <strong>{{secondGName}}</strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="redirectToPrint()" dark right large class="icons8-pdf"></v-icon>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <div id="printMe">
      <v-layout row wrap class="mt-3 pa-3">
        <v-flex xs12 md6 id="second-report">
          <h3>
            Top 5 Sponsors by Air Time
          </h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondSponsorsByAirTime class="limit" />
        </v-flex>
        <v-flex xs12 md6 id="second-report-2">
          <h3>Top 5 Locations by Air Time</h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondLocationsByAirTime />
        </v-flex>
        <v-flex xs12 md6>
          <h3>Top 5 by Ad Frequency</h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondSponsorsByAdFrequency />
        </v-flex>
        <v-flex xs12 md6>
          <h3>Top 5 Sponsors by Dwell Time</h3>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondSponsorsByDwellTime />
        </v-flex>
      </v-layout>
    </div>
    <!--/Charts-->
    <div style="height: 50px !important"></div>
    <!-- bottom navigation -->
    <v-bottom-nav app :active.sync="bottomNav" :value="true" fixed color="white">
      <v-btn color="primary" value="home" flat v-on:click="backToGames()">
        <span>Games</span>
        <v-icon>icons8-stadium</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-layout>
</template>

<script>
import SecondSponsorsByAirTime from "@/components/comparisonCharts/SecondSponsorsByAirTime.vue";
import SecondLocationsByAirTime from "@/components/comparisonCharts/SecondLocationsByAirTime.vue";
import SecondSponsorsByAdFrequency from "@/components/comparisonCharts/SecondSponsorsByAdFrequency.vue";
import SecondSponsorsByDwellTime from "@/components/comparisonCharts/SecondSponsorsByDwellTime.vue";

import Vue from "vue";
import { mapState } from "vuex";

export default {
  name: "ComparisonReportView",
  components: {
    SecondSponsorsByAirTime,
    SecondLocationsByAirTime,
    SecondSponsorsByAdFrequency,
    SecondSponsorsByDwellTime
  },
  data() {
    return {
      active: null,
      bottomNav: "home",
      games: [],
      portalList: [],
      selected: "",
      secondselected: "",
      output: null
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      Portals: state => state.Admin.Portals,
      Documents: state => state.Admin.Documents,
      secondGameID: state => state.game.secondGameID,
      secondGName: state => state.report.secondGameName,
      secondGID: state => state.report.secondGameID
    })
  },
  watch: {
    portal: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    Portals: {
      handler: function() {
        this.portalList = this.Portals;
      },
      deep: true
    },
    Documents: {
      handler: function() {
        this.games = this.Documents;
      },
      deep: true
    },
    DocumentResult: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    loading(val) {
      if (!val) return;
      setTimeout(() => (this.loading = false), 2000);
    }
  },
  methods: {
    initializePage() {
      // second game
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.secondGID,
        "Admin/setDocByID"
      ]);
      var i = 0;
      var secondGName = "";
      for (i = 0; i < this.Documents.length; i++) {
        if (this.secondGID === this.Documents[i].id) {
          secondGName = this.Documents[i].gameName;
          this.$store.commit("report/setValue", [
            "secondGameName",
            secondGName
          ]);
        }
      }
    },
    readGames() {
      this.$store.dispatch("Admin/readDocuments", [
        "games",
        this.portal.active.id,
        "Admin/setDocuments"
      ]);
    },
    backToGames(){
      this.$router.push("/comparisonreport");
    },
    redirectToPrint() {
      this.$htmlToPaper("printMe", () => {
        // console.log("Printing done or got cancelled!");
      });
    }
  },
  mounted() {
    this.readGames();
    this.initializePage();
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  }
};
</script>

<style>
.select-container {
  position: relative;
  z-index: 2;
  margin-top: 10%;
}

.comparison-title {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.report-titles {
  margin-top: 30px !important;
}

@media print {
  .test-print {
    margin-left: 10% !important;
    border: 5px solid black !important;
  }
}

@page {
  margin-top: 20cm;
  margin-bottom: 30cm;
  margin-left: 30cm;
  margin-right: 20cm;
}

.limit {
  page-break-after: always;
}
</style>

